import { PhysicianActions } from 'src/redux/actions/constant';

const {
  GET_ALL_PATIENT_BY_ENTERPRISE_REQUEST,
  GET_ALL_PATIENT_BY_ENTERPRISE_SUCCESS,
  GET_ALL_PATIENT_BY_ENTERPRISE_FAILURE,
  GET_ALL_PATIENT_BY_ENTERPRISE_RESET,
  GET_ALL_PATIENT_BY_ENTERPRISE_LOADING,
} = PhysicianActions;

const initialState: any = {
  isGetTotalPatient: false,
  response: null,
  loading: false,
  totalPatient: [],
  currentPage: -1,
  pageNumber: 0,
};
export const getAllPatientByEnterpriseReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_ALL_PATIENT_BY_ENTERPRISE_SUCCESS: {
      const newPageNumber = action.payload?.data?.data?.number;
      if (state.currentPage + 1 === newPageNumber) {
        return {
          ...state,
          isGetTotalPatient: true,
          response: action.payload,
          loading: false,
          currentPage: newPageNumber,
          totalPatient: [...state.totalPatient, ...action.payload?.data?.data?.content],
          pageNumber: state.pageNumber + 1,
        };
      } else {
        return {
          ...state,
          isGetTotalPatient: true,
          response: action.payload,
          loading: false,
          currentPage: newPageNumber,
          totalPatient: action.payload?.data?.data?.content || [],
        };
      }
    }

    case GET_ALL_PATIENT_BY_ENTERPRISE_FAILURE:
      return {
        ...state,
        isGetTotalPatient: false,
        response: action.payload,
      };

    case GET_ALL_PATIENT_BY_ENTERPRISE_LOADING:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_PATIENT_BY_ENTERPRISE_RESET:
      return initialState;
    default:
      return state;
  }
};
